/// ./src/app/global-error.js
'use client';

import { useEffect } from 'react';
import Rollbar from 'rollbar';
import { clientConfig } from '@/rollbar';

import reportErrorDebounced from '@/lib/reportErrorDebounced';

import Navbar from '@/components/Navbar';
import ErrorMessage from '@/components/ErrorMessage';

// catches errors that occur in root layout page
export default function GlobalError({ error, _reset }: { error: Error; _reset: () => void }) {
  useEffect(() => {
    console.error('Error in global-error.tsx', error);
    const rollbar = new Rollbar(clientConfig);
    reportErrorDebounced(error, rollbar);
  }, [error]);

  return (
    <html>
      <body>
        <Navbar disableSearch={true} />
        <ErrorMessage message='Unexpected Error' subTitle='Oops! Something went wrong.' />
      </body>
    </html>
  );
}
